import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {PARENT_PRODUCT_FIELDS_LIST} from "./design-product.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {getAllDesignInfo, getSingleDesignInfo} from "../../../shopify/services/design-info-data.service";
import {
    DESIGN_INFO_FILTER_FIELDS_FOR_PRODUCTS,
    DESIGN_INFO_IDS,
    DESIGN_INFO_KEYS
} from "../../../shopify/constants/design-info.constant";
import {getDataFromLocalStorage} from "../../../common/utils/local-storage-util";
import DesignInfoFilters from "../../../shopify/components/design-info/design-info-filters";
import ShowBlogPostStatus from "../../../shopify/components/design-blog-post/show-blog-post-status";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import {getAllTags} from "../../../common/services/tag-data-service";
import {getSingleParentProduct, getSingleParentProductById} from "../../../pod/services/parent-product-data-service";

const defaultFilterCriteria: any = {};


const DesignProductsList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [parentProductsList, setParentProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [allDesignInfo, setAllDesignInfo] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const [parentProduct, setParentProduct] = useState(null);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            getAllDesignsDesignInfo();
            getTagsList();
        }
    }, [initialStep]);

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const getAllDesignsDesignInfo = async () => {
        setDataFetchInProgress(true);
        const allDesignInfoResult = await getSingleDesignInfo(DESIGN_INFO_IDS.ALL_DESIGNS);

        setAllDesignInfo(allDesignInfoResult);
        const allParentProducts = _.orderBy(allDesignInfoResult?.filters?.parent?.options, ['label'], ['asc'])
        setParentProductsList(allParentProducts);
        setSelectedParentProduct(allParentProducts[0]);

        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.PRODUCTS_LIST_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    const getParentProductList = async () => {
        setDataFetchInProgress(true);
        const existingAllDesignInfo = {...allDesignInfo};
        const existingFilterCriteria = {...filterCriteria};

        const allParentProducts = existingAllDesignInfo?.filters?.parent?.options;
        let filteredParentProducts = allParentProducts;

        if (!_.isEmpty(existingFilterCriteria)) {
            filteredParentProducts = _.filter(allParentProducts, existingFilterCriteria);
        }

        setParentProductsList(_.orderBy(filteredParentProducts, ['label'], ['asc']));

        if (filteredParentProducts?.length > 0) {
            setSelectedParentProduct(filteredParentProducts[0]);
        } else {
            setSelectedParentProduct(null);
        }

        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getParentProductList();
    }, [filterCriteria]);

    const refreshParentProductList = async () => {
        await getParentProductList();
    }

    useEffect(() => {
        if (selectedParentProduct) {
            getParentProductDetail(selectedParentProduct);
        }
    }, [selectedParentProduct]);

    const getParentProductDetail = async (currentParentProduct) => {
        if (currentParentProduct?.id) {
            const parentProductResult = await getSingleParentProductById(currentParentProduct?.id);
            setParentProduct(parentProductResult);
        } else {
            setParentProduct(null);
        }
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2 w-48'}>
                        Design Products
                    </div>

                    {allDesignInfo &&
                        <div
                            className={'w-full flex justify-start items-start'}>
                            <DesignInfoFilters
                                dataFetchInProgress={false}
                                allDesignInfo={allDesignInfo}
                                showSecondaryFilters={false}
                                allFilterFields={DESIGN_INFO_FILTER_FIELDS_FOR_PRODUCTS}
                                containerClass={''}
                                fieldClass={'w-fit'}
                                filterCriteria={filterCriteria}
                                setFilterCriteria={setFilterCriteria}/>
                        </div>
                    }

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                {/*<div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">

                    </div>
                </div>*/}

            </div>

            <div className="flex justify-start mt-4">

                <div className="w-1/4">

                    <div
                        className={'table-container-with-title-2 bg-white overflow-y-scroll border border-gray-400 rounded-lg'}>

                        <ShowEmptyListMessage
                            dataList={parentProductsList}
                            dataFetchInProgress={false}
                            label={'Parent Products'}/>

                        {parentProductsList?.length > 0 &&
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-8">S.No</th>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 text-left">Name</th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {parentProductsList?.map((parentProduct, rowIndex) => (
                                    <tr key={`row-${rowIndex}`}
                                        onClick={() => {
                                            setSelectedParentProduct(parentProduct);
                                        }}
                                        className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${(selectedParentProduct && selectedParentProduct?.key === parentProduct?.key) ? 'bg-green-200' : ''}`}>
                                        <td className="p-2 m-auto">
                                            <div className="flex justify-center w-8">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        <td className={`p-2 m-auto flex justify-start items-center`}>
                                            <div className={'mr-4'}>
                                                {parentProduct?.label}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        }

                    </div>

                </div>

                <div className={'w-3/4'}>
                    <div className={'mx-4'}>
                        <ShowEmptyListMessage
                            dataList={parentProduct ? [parentProduct] : []}
                            dataFetchInProgress={dataFetchInProgress}
                            label={'Parent Product'}/>

                        {parentProduct &&
                            <ParentProductDetail
                                parentProduct={parentProduct}
                                setParentProduct={setParentProduct}
                                allTags={allTags}/>
                        }
                    </div>
                </div>

            </div>

        </>
    )
}

export default DesignProductsList
